export default __webpack_public_path__ + "static/media/chairs003.4b822a7c.jpeg";